import React from "react";

export function THeaderCell({ children }: { children: React.ReactNode }) {
  return (
    <div className="p-4 text-left text-sm text-primary-light" role="none">
      {children}
    </div>
  );
}
